import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import * as Yup from "yup";
import { useFormik } from "formik";
import { Col, Form, Label, Modal, ModalBody, Row, Input } from "reactstrap";
import Select from 'react-select'
import * as CONSTANTS from "common/utils/data_validations"
import { MODE, TRANSACTION_TYPE, TRUE_AND_FALSE, transactiontypeOptions } from "helpers/sf_constants";
import { getOptionFromValueForSelectBoxWithLabel, getPrimaryButtonClass } from "helpers/sf_utils";

const NAME_AND_TYPE_EXISTS = "Receipt type with this name and type already exists."

const CreateReceiptTypesModal = ({ show: { active, mode, row }, onSubmitUpdatedState, onClickCloseModal, receipt_types }) => {

    const [existReceiptTypeName, setExistReceiptTypeName] = useState(false)
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: mode === MODE.EDIT ? row?.id : null,
            name: mode === MODE.EDIT ? row?.name : "",
            is_debit: mode === MODE.EDIT ? getOptionFromValueForSelectBoxWithLabel(transactiontypeOptions, !!row?.is_debit ? TRANSACTION_TYPE.DEBIT : TRANSACTION_TYPE.CREDIT) : "",
        },
        validationSchema: Yup.object({
            name: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
            is_debit: Yup.object({
                label: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
                value: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
            }),
        }),
        onSubmit: (values, { resetForm }) => {
            const is_debit = values?.is_debit?.label === TRANSACTION_TYPE.DEBIT
            const data =
            {
                name: values?.name,
                is_debit: is_debit
            }
            onSubmitUpdatedState(mode, data);
            resetForm();
        },
    });

    const handleOnClickCloseModal = () => {
        onClickCloseModal();
        validation.resetForm();
    }

    const getIsDebitValue = (isDebitLabel) => {
        if (isDebitLabel?.label === TRANSACTION_TYPE.DEBIT) {
            return TRUE_AND_FALSE.TRUE;
        } else if (isDebitLabel?.label === TRANSACTION_TYPE.CREDIT) {
            return TRUE_AND_FALSE.FALSE;
        } else {
            return null;
        }
    };

    useEffect(() => {
        const is_debit = getIsDebitValue(validation?.values?.is_debit);
        const similarReceiptTypeName = receipt_types?.filter((receipt) => {
            return (
                receipt?.name?.toLowerCase() === validation?.values?.name?.toLowerCase() && !!receipt?.is_debit === is_debit
            )
        })
        if (similarReceiptTypeName.length > 0) {
            setExistReceiptTypeName(true)
        }
        else {
            setExistReceiptTypeName(false)
        }
    }, [validation.values.name, receipt_types, validation.values.is_debit])

    return (
        <Modal size="md" isOpen={active} toggle={handleOnClickCloseModal} centered={true}>
            <div className="modal-body" style={{ overflowY: "hidden" }}>
                <h5 className="modal-title text-black mt-0" id="myModalLabel">
                    {mode === MODE.EDIT ? "Update Receipt Type" : "Create Receipt Type"}
                </h5>

                <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={handleOnClickCloseModal}
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <ModalBody style={{ overflowY: "hidden" }}>
                <Form onSubmit={(e) => {
                    e.preventDefault()
                    validation.handleSubmit();
                    return false;
                }}>
                    <Row>
                        <Col md={12}>
                            <div className="mb-3">
                                <Label htmlFor="name">Name</Label>
                                <Input
                                    type="text"
                                    id="name"
                                    name="name"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.name}
                                    className={
                                        validation.errors.name && validation.touched.name
                                            ? "is-invalid"
                                            : ""
                                    }
                                />
                                {validation.errors.name && validation.touched.name && (
                                    <div className="invalid-feedback">
                                        {validation.errors.name}
                                    </div>
                                )}

                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="mb-3">
                                <Label htmlFor="is_debit">Transaction Type</Label>
                                <Select
                                    options={transactiontypeOptions}
                                    classNamePrefix="select2-selection"
                                    onChange={selectedOption => {
                                        let event = {
                                            target: {
                                                name: "is_debit",
                                                value: selectedOption,
                                            },
                                        }
                                        validation.handleChange(event)
                                    }}
                                    onBlur={() => {
                                        validation.handleBlur({
                                            target: { name: "is_debit" },
                                        })
                                    }}
                                    value={validation.values.is_debit || ""}
                                    invalid={
                                        validation.touched.is_debit &&
                                            validation.errors.is_debit
                                            ? true
                                            : false
                                    }
                                />
                                {validation.touched.is_debit &&
                                    validation.errors.is_debit ? (
                                    <small className="text-danger">
                                        {CONSTANTS.STR_REQUIRED_FIELD}
                                    </small>
                                ) : null}
                            </div>
                        </Col>
                        {existReceiptTypeName &&
                            <div className="text-danger">
                                {NAME_AND_TYPE_EXISTS}
                            </div>
                        }
                        <Col md={12}>
                            <div className="mt-4 float-end">
                                <button className={`btn ${getPrimaryButtonClass()} w-md`} type="submit" name="submit" disabled={existReceiptTypeName}>
                                    {mode === MODE.EDIT ? "Update" : "Save"}
                                </button>
                                <button type="button" className="btn btn-light ms-2 w-md" name="close" onClick={handleOnClickCloseModal}>
                                    Cancel
                                </button>
                            </div>
                        </Col>
                    </Row>

                </Form>
            </ModalBody>
        </Modal>
    )
}

CreateReceiptTypesModal.propTypes = {
    onClickCloseModal: PropTypes.func,
    show: PropTypes.object,
}

export default CreateReceiptTypesModal;
